export const COUNTRY_DEFINITIONS = "/Country/GetAllCountry"
export const COUNTRY_INSERT = "/Country/InsertCountry"
export const COUNTRY_UPDATE = "/Country/UpdateCountry"
export const COUNTRY_DELETE = "/Country/DeleteCountry"